import React, { useContext, useEffect, useState } from 'react';
import { getTextLang, LanguageContext } from './providers/LanguageProvider';
import { UserAction, UserContext } from './providers/UserProvider';
import { Button, Card, Container, ContainerFlex, TextLocalized } from './styled/Styled';
import { ModalBusinessCase } from './util/ModalUtil';
import { getProgressData } from './util/BlockUtil';

const GoodPracticeTypeItem = ({ item, showIndicator }) => {
    const [showList, setShowList] = useState(false);
    const { dispatch } = useContext(UserContext);
    const { language, dictionary } = useContext(LanguageContext);

    const [progress, setProgress] = useState({ scrore: 0, color: "color-red" });

    useEffect(() => {
        getProgress();
    }, [item])

    const showBusinessCases = () => {
        dispatch({ action: UserAction.showModal, data: { show: true, body: <ModalBusinessCase items={item.goodpractices} /> } })
    }

    const getProgress = () => {
        //Comprobar si la estrategia aplica al usuario
        if (item.questions.filter(question => {
            return question.answers.filter(answer => answer.weight == -1 && answer.user_answer != null).length > 0
        }).length == item.questions.length) {
            setProgress({
                color: "color-white",
                score: -1
            })
        } else {
            let totalPoints = Math.round(item.questions.filter(question => {
                return question.answers.filter(answer => answer.weight == -1 && answer.user_answer != null).length == 0
            }).reduce((acc, question) => acc + (question.weight * 4), 0));

            let currentPoints = item.questions.filter(question => {
                question.answers = question.answers.filter(answer => answer.weight != -1 && answer.user_answer != null);
                return question.answers.length > 0;
            }).reduce((acc, question) => acc + (question.weight * question.answers[0].weight), 0);

            console.log(`${item.name}: Total points ${totalPoints} - Current points ${currentPoints}`);
            let score = (currentPoints / totalPoints) * 100;
            setProgress({
                color: getProgressData(score).color,
                score: score
            })
        }
    }

    return <Container width="12" px="4" position="relative">
        {
            showList ?
                <Card flex shadowOn width="12" align="stretch" color="color-white">
                    <Button onClick={() => setShowList(!showList)} flex width="12" px="16" align="center" color={"color-gray-card"} radiusbl="0px" radiusbr="0px">
                        <Container width="wrap" fontSize="18px" fontWeight="bold" fontColor="color-black" children={`${getTextLang(item, 'name', language)}`} />
                    </Button>
                    <Container width="12" height="1px" color="color-gray" />
                    <ContainerFlex width="12" justify="center" px="16">
                        <Container width="12" mb="16" fontSize="15px" fontWeight="300" dangerouslySetInnerHTML={{ __html: getTextLang(item, 'description', language) }} />
                        <ContainerFlex width="wrap">
                            <Card title={dictionary['msgDifficultyAlt']} pv="4" ph="8" border="solid" fontSize="12px" fontColor="color-white" color="color-black" borderColor="color-black" borderWidth="2px" children={`${getTextLang(item.difficulty, 'name', language)}`} />
                            <Card title={dictionary['msgBusinessBlockAlt']} mh="8" pv="4" ph="8" border="solid" fontSize="12px" fontColor="color-black" color="color-primary" borderColor="color-primary" borderWidth="2px" children={`${getTextLang(item.business_dynamics, 'name', language)}`} />
                            <Card title={dictionary['msgImpactBlockAlt']} pv="4" ph="8" border="solid" fontSize="12px" fontColor="color-white" color="color-green-dark" borderColor="color-green-dark" borderWidth="2px" children={`${getTextLang(item.business_factors, 'name', language)}`} />
                        </ContainerFlex>
                        {
                            item.goodpractices.length > 0 ?
                                <ContainerFlex width="12" ph="8" justify="flex-end">
                                    <Button onClick={showBusinessCases} shadowOn pv="8" ph="12" color="color-green-dark" hoverColor="color-black"
                                        fontColor="color-white" fontWeight="bold" fontSize="14px" textAlign="center"
                                        children={<TextLocalized children={item.goodpractices.length === 1 ? "actionBusinessCase" : "actionBusinessCases"} />} />
                                </ContainerFlex>
                                : null
                        }
                    </ContainerFlex>
                </Card>
                :
                <Card flex shadowOn width="12" align="stretch" color="color-white">
                    <Button onClick={() => setShowList(!showList)} width="12" px="16" fontSize="18px" fontWeight="bold" children={`${getTextLang(item, 'name', language)}`} />
                </Card>
        }
        {
            showIndicator ?
                <Card width="20px" display={progress.scrore === -1 ? "none" : "block"} height="20px" position="absolute" top="25px" right="10px" radius="10px" color={progress.color} />
                : null
        }
    </Container>
}

export default GoodPracticeTypeItem;